// eslint-disable-next-line
if (process.env.NODE_ENV === 'development') {
    module.exports = require('./createStore.dev');
} else {
    module.exports = require('./createStore.prod');
}


/** WEBPACK FOOTER **
 ** ./src/store/createStore.js
 **/